import { useRegisterSW } from 'virtual:pwa-register/react';
// Deep import: also mounted in the university app, which must not pull the @/core/ui barrel.
import { toaster } from '@/core/ui/Overlay/Toast/Toast';

export const VersionManager = () => {
  const { updateServiceWorker } = useRegisterSW({
    onRegisterError(error) {
      console.error(error);
    },
    onNeedRefresh() {
      toaster.updateToast(() => {
        updateServiceWorker(true);
      });
    },
  });

  return null;
};
